import Alert from "@mui/material/Alert";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import TuneRoundedIcon from "@mui/icons-material/TuneRounded";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import Skeleton from "@mui/material/Skeleton";
import Snackbar from "@mui/material/Snackbar";
import Tooltip from "@mui/material/Tooltip";
import { toPng } from "html-to-image";
import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import { ScrollMenu, VisibilityContext } from "react-horizontal-scrolling-menu";
import { useLocation, useNavigate } from "react-router-dom";

import LinearProgress from "@mui/material/LinearProgress";
import Modal from "@mui/material/Modal";
import { CommissionModal } from "components/app-modals";
import Badge from "components/badge";
import Banner from "components/banner";
import Button from "components/button";
import FilterCollapse from "components/filterCollapse";
import ResultCard from "components/resultCard";
import ShareQuatePrice from "components/share-quote-price";
import SideBar from "components/sideBar";
import ModalCom from "components/swipeDrawer";

import { ReactComponent as Airplate } from "assets/images/airplate.svg";
import { ReactComponent as ArrowDown } from "assets/images/arrowDown.svg";
import { ReactComponent as CalPrice } from "assets/images/calPrice.svg";

import useApi from "hooks/useApi";
import { useTranslation } from "i18n";
import { capitalizeFirstLetter } from "utils/Utils";

import { createCancelSource } from "api/client";
import { flightSearch, getCalendar } from "api/Flights";
import _ from "lodash";
import moment from "moment";
import "moment/locale/nl";
import { CurrencyContext } from "../useContext";

import { roundPrice } from "utils/packageDealPrice";
import { checkISAdminOrEmployee, generateAmaRefId } from "utils/Utils";

import useFilter from "components/filterConfiguration";
import Iconify from "components/iconify";
import "./style.css";

const Search = ({ setRedirectLink }) => {
  const { search, state } = useLocation();
  let searchParams = new URLSearchParams(search);
  const { locale, t } = useTranslation();

  const { currency, setCurrency } = useContext(CurrencyContext);
  const [closePriceModal, setCloseModalPrice] = useState(false);
  const [data, setData] = useState([]);
  const [selectedFlight, setSelectedFlight] = useState();
  const [calendarErr, setCalendarErr] = useState(false);
  const [source, setSource] = useState("");
  const [departureDates, setdepartureDates] = useState([]);
  const [returnDates, setReturnDates] = useState([]);
  const [sortedPrices, setSortedPrices] = useState([]);

  const departureDateFromURL = searchParams.get("departure-date");

  const [nextDate, setNaxtDate] = useState(departureDateFromURL?.split("~")[0]);

  const [nextReturnDate, setNaxtReturnDate] = useState(
    searchParams.get("return-date")
      ? searchParams.get("return-date")?.split("~")[0]
      : departureDateFromURL?.split("~")[
          departureDateFromURL?.split("~").length - 1
        ]
  );
  const [calendarLoading, setCalendarLoading] = useState([]);
  // Guards against stale calendar responses overwriting the UI when filters
  // (e.g. checked baggage) are toggled in quick succession. The cancel source
  // aborts the previous in-flight calendar fetch as soon as a new one starts
  // (and on unmount), while the request id is a backup for the rare case the
  // response is already in the JS task queue when cancel() is called.
  const calendarRequestIdRef = useRef(0);
  const calendarCancelSourceRef = useRef(null);
  const [activePrice, setActivePrice] = useState({
    return: null,
    departure: null,
  });
  const [amaRefId, setAmaRefId] = useState(generateAmaRefId());
  const [openPop, setOpenPop] = useState(false);
  const [loading, setLoading] = useState(false);
  const [disabledSearch, setDisabledSearch] = useState(false);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [openMobileFilter, setOpenMobileFilter] = useState(false);
  const [openPriTable, setOpenPriTable] = useState(true);
  const [filters, setFilters] = useState([]);
  const [includedCarrierCodes, setIncludedCarrierCodes] = useState([]);
  const [searchWithNDC, setSearchWithNDC] = useState("GDS");
  const [resetSource, setResetSource] = useState(false);
  const [airlinesCodes, setAirlinesCodes] = useState([]);

  const [open2, setOpen2] = useState(false);
  const [flight, setFlight] = useState(false);
  const [ndcPrice, setNdcPrice] = useState();
  const [departureDate, setdepartureDate] = useState(
    searchParams.get("departure-date") ?? ""
  );
  const [returnDate, setReturnDate] = useState(
    searchParams.get("return-date") ?? ""
  );
  const [isSearchFormOpen, setIsSearchFormOpen] = useState(false);
  const [cheaperPriceToastOpen, setCheaperPriceToastOpen] = useState(false);
  // Bumped on pricing-table click so we always start a search after navigate.
  const [calendarSelectVersion, setCalendarSelectVersion] = useState(0);
  // Set on pricing-table click; evaluated only after the post-click search has
  // actually entered loading and then finished with results.
  const calendarClickPendingRef = useRef(null);
  // Ensures the first landing search also gets one toast/scroll evaluation once
  // both flight results and calendar fares are available.
  const initialDealEvaluatedRef = useRef(false);
  const lastCheaperEvalRef = useRef("");
  const firstResultCardRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    setIsSearchFormOpen(false);
  }, [search]);

  const searchSummary = useMemo(() => {
    const parseCity = (value) => {
      if (!value) return { code: "", name: "" };
      const [code, ...nameParts] = value.split("-");
      return {
        code: code?.toUpperCase() || "",
        name: nameParts.join("-") || "",
      };
    };

    const origins = (searchParams.get("origin") || "").split("~").filter(Boolean);
    const destinations = (searchParams.get("destination") || "")
      .split("~")
      .filter(Boolean);
    const origin = parseCity(origins[0]);
    const destination = parseCity(destinations[destinations.length - 1]);
    const flightType = searchParams.get("flight") || "Return";
    const departure = searchParams.get("departure-date")?.split("~")?.[0] || "";
    const returnDateValue =
      searchParams.get("return-date")?.split("~")?.[0] || "";
    const travelerCount =
      (+searchParams.get("Senior") || 0) +
      (+searchParams.get("Adults") || 0) +
      (+searchParams.get("Children") || 0) +
      (+searchParams.get("Infants") || 0);
    const cabinKey = searchParams.get("cabinType") || "ECONOMY";
    const cabinLabelMap = {
      ECONOMY: t("banner.economy"),
      PREMIUM_ECONOMY: t("banner.premiumEconomy"),
      BUSINESS: t("banner.business"),
      FIRST: t("banner.firstClass"),
      Economy: t("banner.economy"),
      "Premium Economy": t("banner.premiumEconomy"),
      Business: t("banner.business"),
      "First Class": t("banner.firstClass"),
    };
    const tripLabelMap = {
      Return: t("banner.return"),
      "One-way": t("banner.oneWay"),
      "Multi-city": t("banner.multiCity"),
    };

    const formatSummaryDate = (date) =>
      moment(date).locale(locale).format("ddd D MMM");

    let dateLabel = departure ? formatSummaryDate(departure) : "";
    if (flightType === "Return" && returnDateValue) {
      dateLabel = `${formatSummaryDate(departure)} – ${formatSummaryDate(
        returnDateValue
      )}`;
    } else if (flightType === "Multi-city") {
      const legs = (searchParams.get("departure-date") || "")
        .split("~")
        .filter(Boolean);
      if (legs.length > 1) {
        dateLabel = `${formatSummaryDate(legs[0])} – ${formatSummaryDate(
          legs[legs.length - 1]
        )}`;
      }
    }

    return {
      origin,
      destination,
      flightType,
      tripLabel: tripLabelMap[flightType] || flightType,
      dateLabel,
      travelerCount,
      cabinLabel: cabinLabelMap[cabinKey] || t("banner.economy"),
    };
  }, [search, locale, t]);

  const searchForFlights = useApi(flightSearch, source, setSearchWithNDC, {
    cancelInflight: true,
  });
  const { allFilters, setAllFilters } = useFilter(
    JSON.parse(searchParams.get("refundableFare")),
    JSON.parse(searchParams.get("checkedbaggage")),
    searchParams.get("satyamSpecial"),
    JSON.parse(searchParams.get("stops")),
    searchParams.get("cabinType"),
    searchParams.get("officeId")
  );

  const formatDateToMoment = (date) => {
    return moment(date).locale(locale).format("ddd D MMM");
  };
  const getAirportCode = (value) => value?.split("-")?.[0]?.toUpperCase();
  const routeOriginCode = getAirportCode(searchParams.get("origin")?.split("~")?.[0]);
  const routeDestinationCode = getAirportCode(
    searchParams.get("destination")?.split("~")?.at(-1),
  );
  const isTwoCheckedBaggageRoute =
    (routeOriginCode === "AMS" && routeDestinationCode === "PBM") ||
    (routeOriginCode === "PBM" && routeDestinationCode === "AMS");

  const checkIfdepartureDateIsTodayORTomorrow = (type) => {
    if (type === "return-date") {
      return nextReturnDate;
    } else {
      const today = new Date();
      const getdepartureDate = new Date(nextDate);

      if (formatDateToMoment(today) === formatDateToMoment(getdepartureDate)) {
        return moment(
          new Date(nextDate).setDate(new Date(nextDate).getDate() + 3)
        ).format("Y-MM-DD");
      } else if (
        getdepartureDate.getMonth() === new Date().getMonth() &&
        getdepartureDate.getFullYear() === new Date().getFullYear() &&
        getdepartureDate.getDate() === new Date().getDate() + 1
      ) {
        return moment(
          new Date(nextDate).setDate(new Date(nextDate).getDate() + 2)
        ).format("Y-MM-DD");
      } else {
        return nextDate;
      }
    }
  };

  const travelers = [];
  [
    ...Array(+searchParams.get("Senior")).fill("SENIOR"),
    ...Array(+searchParams.get("Adults")).fill("ADULT"),
    ...Array(+searchParams.get("Children") || 0).fill("CHILD"),
    ...Array(+searchParams.get("Infants") || 0).fill("HELD_INFANT"),
  ].map((item, index) => {
    const obj = {
      id: index + 1 + "",
      travelerType: item,
      fareOptions: ["STANDARD"],
      ...(item === "HELD_INFANT" && {
        associatedAdultId:
          travelers?.filter((test) => test.travelerType === "HELD_INFANT")
            ?.length +
          1 +
          "",
      }),
    };
    travelers.push(obj);
  });

  const getFlightDestinations = (type) => {
    const originDestinations = [];
    const flightOption = searchParams.get("flight");

    const origins = searchParams.get("origin").split("~");
    const destinations = searchParams.get("destination").split("~");

    const originsDates = searchParams.get("departure-date").split("~");

    if (flightOption === "Return") {
      const destinationsDates = searchParams.get("return-date").split("~");

      origins.push(destinations[0]);
      destinations.push(origins[0]);
      originsDates.push(destinationsDates[0]);
    }

    const calenderDates = originsDates.map((_, index) => {
      if (index === 0)
        return checkIfdepartureDateIsTodayORTomorrow("departure-date");
      if (index === originsDates.length - 1)
        return checkIfdepartureDateIsTodayORTomorrow("return-date");
      return originsDates[index];
    });

    origins.map((item, index) => {
      const obj = {
        id: index + 1 + "",
        originLocationCode: item.split("-")[0],

        destinationLocationCode: destinations[index].split("-")[0],
        departureDateTimeRange: {
          date:
            type === "calendar" ? calenderDates[index] : originsDates[index],
          ...(type === "calendar" && { dateWindow: "I3D" }),
        },
      };

      originDestinations.push(obj);
    });

    return originDestinations;
  };

  const commonParams = {
    travelers,
    ...(searchParams.get("cabinType") && {
      cabin: searchParams.get("cabinType"),
    }),
    ...(searchParams.get("officeId") && {
      officeId: searchParams.get("officeId"),
    }),

    currencyCode: currency?.currency,
    ...(includedCarrierCodes?.length > 0 && { includedCarrierCodes }),
    includedCheckedBagsOnly: JSON.parse(searchParams.get("checkedbaggage")),
    refundableFare: JSON.parse(searchParams.get("refundableFare")),
    maxNumberOfConnections: +searchParams.get("stops"),

    fareType: searchParams.get("satyamSpecial"),
  };

  const fetchCalendarFareData = async () => {
    // Call the calender just in case the multiCity is less than 3 destinations

    const originsDates = searchParams.get("origin").split("~");

    if (originsDates.length < 3) {
      calendarCancelSourceRef.current?.cancel("superseded");
      const cancelSource = createCancelSource();
      calendarCancelSourceRef.current = cancelSource;

      const requestId = ++calendarRequestIdRef.current;
      setCalendarLoading(true);
      setCalendarErr(false);
      const calendar = await getCalendar(
        {
          originDestinations: getFlightDestinations("calendar"),

          amaRefId,
          ...commonParams,
        },
        { cancelToken: cancelSource.token }
      );

      // A newer calendar request was started while we were awaiting; let it
      // own the state so we don't render results for outdated filters.
      if (requestId !== calendarRequestIdRef.current) return;

      // Request was cancelled (newer one fired, or component unmounting). Do
      // not flip loading off or surface an error — the successor (if any)
      // will manage state.
      if (calendar?.problem === "CANCEL_ERROR") return;

      if (calendar.ok) {
        setData(calendar?.data);
        // if (airlinesCodes?.length === 0) {
        setAirlinesCodes(calendar?.data?.carriers);
        // }
        fetchdepartureAndReturnDate(calendar?.data?.response);
        if (calendar?.data?.response?.length === 0) {
          setCalendarErr(true);
        }
      } else {
        setCalendarErr(true);
      }

      setCalendarLoading(false);
    }
  };

  const fetchSearchFlights = async (hideSource) => {
    if (!closePriceModal) {
      setCloseModalPrice(false);
    }
    if (calendarClickPendingRef.current) {
      calendarClickPendingRef.current.searchStarted = true;
    }
    searchForFlights.request({
      originDestinations: getFlightDestinations(),
      ...(source && !hideSource && { source }),

      amaRefId,
      ...commonParams,
    });
  };

  useEffect(() => {
    const selectedCurrency = searchParams.get("currency");

    if (selectedCurrency) {
      // setCurrency(allAppCurrencies.find((i) => i.currency === currency));
      setCurrency({ selectedCurrency });
    }
  }, []);

  // Abort any in-flight calendar fetch when the page unmounts so we don't
  // keep an expensive GDS call alive after the user navigates away.
  useEffect(() => {
    return () => {
      calendarCancelSourceRef.current?.cancel("unmount");
    };
  }, []);

  useEffect(() => {
    if (filters.length === 0) {
      updateFilter();
    }
    if (resetSource && source) {
      if (amaRefId && currency && !disabledSearch) {
        fetchSearchFlights();
      }
    }
  }, [source]);

  useEffect(() => {
    if (!resetSource) {
      setResetSource(true);
    }
  }, []);

  useEffect(() => {
    if (resetSource) {
      setSource("");

      if (amaRefId && currency && !window.location.hash) {
        get3DatesBeforeAndAfter();
        fetchCalendarFareData();
        fetchSearchFlights("hideSource");
      }
    }
  }, [currency, window.location.hash]);

  useEffect(() => {
    if (amaRefId && currency) {
      if (!disabledSearch) {
        fetchSearchFlights();
      }
      get3DatesBeforeAndAfter();
      fetchCalendarFareData();
    }
  }, [nextDate, nextReturnDate, amaRefId, allFilters, includedCarrierCodes]);

  // Pricing-table selection: always refresh flight results after navigate so
  // cheaper-price toast / auto-scroll have a clean loading cycle to hook into.
  useEffect(() => {
    if (calendarSelectVersion === 0) return;
    if (!amaRefId || !currency) return;

    fetchSearchFlights("hideSource");
  }, [calendarSelectVersion]);

  const fetchdepartureAndReturnDate = async (flightOptions) => {
    try {
      const departureDates = [];
      const returnDates = [];
      const prices = [];
      flightOptions.forEach((flightOption) => {
        departureDates.push(flightOption?.departure?.split("T")[0]);
        returnDates.push(flightOption?.return?.split("T")[0]);
        prices.push(flightOption.price);
      });
      const uniqueAndSorteddepartureDates = _.uniqBy(departureDates).sort(
        (a, b) => new Date(a) - new Date(b)
      );
      const uniqueAndSortedReturnDates = _.uniqBy(returnDates).sort(
        (a, b) => new Date(a) - new Date(b)
      );

      setdepartureDates(uniqueAndSorteddepartureDates);
      setReturnDates(uniqueAndSortedReturnDates);
      setSortedPrices(_.uniqBy(prices).sort((a, b) => a - b));
    } catch (err) {
      return;
    }
  };

  const getPriceBasedOndepartureAndReturnDate = (departureDate, returnDate) => {
    if (data?.response) {
      const flightOption = data?.response?.filter(
        (flightOption) =>
          flightOption?.departure?.split("T")[0] === departureDate &&
          flightOption?.return?.split("T")[0] === returnDate
      );
      if (flightOption.length === 1) {
        return flightOption[0];
      }
    }
  };

  const getPriceBasedOndepartureDate = (departureDate) => {
    if (data?.response) {
      const flightOption = data?.response?.filter(
        (flightOption) =>
          moment(flightOption.departure).format("YYYY-MM-DD") ===
          moment(departureDate).format("YYYY-MM-DD")
      );

      if (flightOption.length === 1) {
        return flightOption[0];
      }
    }
  };

  const getTravelRange = (type, dateRange) => {
    const firstDay = dateRange[0];
    const lastDay = dateRange[dateRange.length - 1];
    return `${type} ${moment(firstDay).locale(locale).format("MMM D")} - ${moment(
      lastDay
    )
      .locale(locale)
      .format("MMM D")}`;
  };

  const clearCalendarHover = () => {
    setActivePrice({
      return: null,
      departure: null,
    });
  };

  const parseMoney = (value) => {
    if (value == null || value === "") return NaN;
    if (typeof value === "number") return value;
    const normalized = String(value).replace(/[^0-9.-]/g, "");
    return Number(normalized);
  };

  const getSelectedCalendarFare = () => {
    const flightType = searchParams.get("flight");
    const selectedDeparture = nextDate
      ? moment(nextDate).format("YYYY-MM-DD")
      : "";

    if (flightType === "One-way") {
      return getPriceBasedOndepartureDate(selectedDeparture)?.price;
    }

    const selectedReturnRaw =
      flightType === "Return"
        ? nextReturnDate
        : nextReturnDate ||
          searchParams.get("departure-date")?.split("~")?.at(-1);
    const selectedReturn = selectedReturnRaw
      ? moment(selectedReturnRaw).format("YYYY-MM-DD")
      : "";

    return getPriceBasedOndepartureAndReturnDate(
      selectedDeparture,
      selectedReturn
    )?.price;
  };

  const scrollToFirstResultCard = () => {
    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => {
        const card = firstResultCardRef.current;
        if (!card) return;

        const rect = card.getBoundingClientRect();
        const cardTop = rect.top + window.scrollY;
        const cardBottom = rect.bottom + window.scrollY;
        const viewportHeight = window.innerHeight;
        const stickyOffset = window.innerWidth < 576 ? 88 : 120;
        const bottomPadding = 12;
        const maxScroll = Math.max(
          0,
          document.documentElement.scrollHeight - viewportHeight
        );

        // Align the card so its bottom sits at the bottom of the viewport —
        // fully visible, without scrolling past that point.
        let target = cardBottom - viewportHeight + bottomPadding;

        // If the card is taller than the available area under the sticky bar,
        // fall back to pinning its top just below the sticky search bar.
        const availableHeight = viewportHeight - stickyOffset - bottomPadding;
        if (rect.height > availableHeight) {
          target = cardTop - stickyOffset;
        }

        window.scrollTo({
          top: Math.min(maxScroll, Math.max(0, target)),
          behavior: "smooth",
        });
      });
    });
  };

  const applyCheaperPriceDeal = (calendarPrice, { scroll = true } = {}) => {
    const flights = searchForFlights?.data?.response?.data;
    const firstFlight = Array.isArray(flights) ? flights[0] : null;
    if (!firstFlight) {
      setCheaperPriceToastOpen(false);
      return false;
    }

    const parsedCalendarPrice = parseMoney(calendarPrice);
    const firstCardPrice = parseMoney(totalPrice(firstFlight));
    const isCheaper =
      Number.isFinite(parsedCalendarPrice) &&
      Number.isFinite(firstCardPrice) &&
      parsedCalendarPrice > firstCardPrice;

    lastCheaperEvalRef.current = `${firstFlight?.id}-${firstCardPrice}-${parsedCalendarPrice}`;
    setCheaperPriceToastOpen(isCheaper);

    if (isCheaper && scroll) {
      scrollToFirstResultCard();
    }

    return isCheaper;
  };

  const handleFlightOptionClick = (departureDate, returnDate, calendarPrice) => {
    setSource("");
    setDisabledSearch(false);
    // Drop hover/trace so highlights snap to the newly selected dates
    // (also covers cases where mouseleave never fires after remount).
    clearCalendarHover();
    const formattedDeparture = moment(departureDate).format("YYYY-MM-DD");
    const formattedReturn = returnDate
      ? moment(returnDate).format("YYYY-MM-DD")
      : "";

    const clickedPrice = parseMoney(calendarPrice);
    // Calendar-click flow owns the evaluation; skip the initial-search pass.
    initialDealEvaluatedRef.current = true;
    calendarClickPendingRef.current = {
      price: Number.isFinite(clickedPrice) ? clickedPrice : null,
      scroll: true,
      searchStarted: false,
      sawLoading: false,
    };
    setCheaperPriceToastOpen(false);

    if (searchParams.get("flight") === "Return") {
      searchParams.set("return-date", formattedReturn);
      searchParams.set("departure-date", formattedDeparture);

      setReturnDate(formattedReturn);
      setNaxtReturnDate(formattedReturn);
    }
    if (searchParams.get("flight") === "Multi-city") {
      searchParams.set(
        "departure-date",
        formattedDeparture + "~" + formattedReturn
      );
      setReturnDate(formattedReturn);
      setNaxtReturnDate(formattedReturn);
    } else {
      searchParams.set("departure-date", formattedDeparture);
    }

    setNaxtDate(formattedDeparture);
    navigate({
      pathname: `/search`,
      search: searchParams.toString(),
    });
    setdepartureDate(searchParams.get("departure-date"));
    // Trigger a search on the next render (after URL params update) so toast
    // and scroll still run even when the selected dates were unchanged.
    setCalendarSelectVersion((version) => version + 1);
  };

  const toDayKey = (date) => (date ? moment(date).format("YYYY-MM-DD") : "");

  const getPricingTier = (price) => {
    if (!price || !sortedPrices?.length) return "";
    return parseInt(price) <= parseInt(sortedPrices[2]) ? "cheap" : "expensive";
  };

  const getCalendarFocusIndices = () => {
    const hoverActive =
      Number.isInteger(activePrice.departure) &&
      Number.isInteger(activePrice.return);

    if (hoverActive) {
      return {
        departure: activePrice.departure,
        return: activePrice.return,
        fromHover: true,
      };
    }

    // No hover: keep the crosshair on the currently selected dates.
    return {
      departure: departureDates.findIndex(
        (date) => toDayKey(date) === toDayKey(nextDate)
      ),
      return: returnDates.findIndex(
        (date) => toDayKey(date) === toDayKey(nextReturnDate)
      ),
      fromHover: false,
    };
  };

  const getReturnMatrixCellClass = (
    departureDate,
    returnDate,
    departureIndex,
    returnIndex,
    price
  ) => {
    const focus = getCalendarFocusIndices();
    const isSelected =
      toDayKey(departureDate) === toDayKey(nextDate) &&
      toDayKey(returnDate) === toDayKey(nextReturnDate);
    const isHoverTarget =
      focus.fromHover &&
      departureIndex === focus.departure &&
      returnIndex === focus.return;
    const hasFocus = focus.departure >= 0 && focus.return >= 0;
    const isTrace =
      hasFocus &&
      !isSelected &&
      !isHoverTarget &&
      ((returnIndex <= focus.return && departureIndex === focus.departure) ||
        (returnIndex === focus.return && departureIndex >= focus.departure));
    const tier = getPricingTier(price);

    return [
      "price-cell",
      price ? "has-price" : "",
      isSelected || isHoverTarget ? "is-selected" : "",
      isTrace ? "is-trace" : "",
      tier === "cheap" ? "is-cheap" : "",
      tier === "expensive" ? "is-expensive" : "",
    ]
      .filter(Boolean)
      .join(" ");
  };

  const getOneWayCellClass = (departureDate, price) => {
    const isSelected = toDayKey(departureDate) === toDayKey(nextDate);
    const tier = getPricingTier(price);

    return [
      "price-cell",
      price ? "has-price" : "",
      isSelected ? "is-selected" : "",
      tier === "cheap" ? "is-cheap" : "",
      tier === "expensive" ? "is-expensive" : "",
    ]
      .filter(Boolean)
      .join(" ");
  };

  const get3DatesBeforeAndAfter = () => {
    // Build the visible date window as local YYYY-MM-DD strings (same format
    // the calendar API returns) so headers don't shift a day while loading.
    const departure = [];
    const returnDate = [];
    ["departure-date", "return-date"].forEach((type) => {
      const base = moment(
        checkIfdepartureDateIsTodayORTomorrow(type),
        "YYYY-MM-DD"
      );
      [...Array(7)].forEach((_, index) => {
        const date = base
          .clone()
          .add(index - 3, "days")
          .format("YYYY-MM-DD");
        if (type === "departure-date") {
          departure.push(date);
        } else {
          returnDate.push(date);
        }
      });
    });
    setdepartureDates(departure);
    setReturnDates(returnDate);
  };

  const isReturnTrip = searchParams.get("flight") !== "One-way";

  const canGoPreviousDeparture = !moment(nextDate)
    .subtract(7, "days")
    .isBefore(moment(), "day");

  const canGoNextDeparture =
    !isReturnTrip || !nextReturnDate
      ? true
      : moment(nextDate).add(7, "days").isBefore(moment(nextReturnDate), "day");

  const canGoPreviousReturn = moment(nextReturnDate)
    .subtract(7, "days")
    .isAfter(moment(nextDate), "day");

  const handleNextCalendarBtn = () => {
    if (!canGoNextDeparture) return;
    setSource("");
    setDisabledSearch(true);
    setNaxtDate(moment(nextDate).add(7, "days").format("YYYY-MM-DD"));
  };

  const handlePreviousCalendarBtn = () => {
    if (!canGoPreviousDeparture) return;
    setSource("");
    setDisabledSearch(true);
    setNaxtDate(moment(nextDate).subtract(7, "days").format("YYYY-MM-DD"));
  };

  const handleNextReturnCalendarBtn = () => {
    setSource("");
    setDisabledSearch(true);
    setNaxtReturnDate(
      moment(nextReturnDate).add(7, "days").format("YYYY-MM-DD")
    );
  };

  const handlePreviousReturnCalendarBtn = () => {
    if (!canGoPreviousReturn) return;
    setSource("");
    setDisabledSearch(true);
    setNaxtReturnDate(
      moment(nextReturnDate).subtract(7, "days").format("YYYY-MM-DD")
    );
  };

  const toggleDrawer = (open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setOpenDrawer(open);

    if (!open) {
      setCloseModalPrice(true);
    }
  };

  const totalPrice = (currentFlight) => {
    const flight = currentFlight;
    const fareAdjustment = searchForFlights?.data?.response?.fareAdjustment;

    const priceWithFareAdjust =
      fareAdjustment && Object.keys(fareAdjustment)?.length > 0
        ? (
            flight?.price?.total * 1 +
            (fareAdjustment[flight?.id] ? fareAdjustment[flight?.id] : 0)
          ).toFixed(2)
        : flight?.price?.total;

    return priceWithFareAdjust;
  };

  // After a pricing-table click: scroll to the first result card, and celebrate
  // when that fare beats the calendar price.
  //
  // Important: fetchSearchFlights() only schedules setLoading(true). In the same
  // effect flush, loading is still false and data is still the previous search.
  // We must wait until we observe loading===true for the post-click fetch
  // before comparing — otherwise we clear the pending click against stale data
  // and the toast never appears.
  useEffect(() => {
    const pending = calendarClickPendingRef.current;
    if (!pending) return;

    if (searchForFlights.loading) {
      if (pending.searchStarted) {
        pending.sawLoading = true;
      }
      return;
    }

    // Post-click search has not started, or has not been observed loading yet.
    if (!pending.searchStarted || !pending.sawLoading) return;

    // Failed search — don't compare against a previous response still in state.
    if (searchForFlights.error) {
      calendarClickPendingRef.current = null;
      return;
    }

    const flights = searchForFlights?.data?.response?.data;
    if (!Array.isArray(flights)) return;

    if (!flights[0]) {
      calendarClickPendingRef.current = null;
      return;
    }

    const calendarPrice = pending.price;
    const shouldScroll = pending.scroll;
    calendarClickPendingRef.current = null;
    applyCheaperPriceDeal(calendarPrice, { scroll: shouldScroll });
  }, [searchForFlights.loading, searchForFlights.data, searchForFlights.error]);

  // After every completed search (landing, calendar click, or filter change):
  // celebrate when the first result still beats the selected calendar fare.
  useEffect(() => {
    if (calendarClickPendingRef.current) return;
    if (searchForFlights.loading || searchForFlights.error) return;
    if (calendarLoading === true) return;

    const flights = searchForFlights?.data?.response?.data;
    if (!Array.isArray(flights) || !flights[0]) return;

    // Wait until calendar fares have loaded for this search.
    if (!Array.isArray(data?.response)) return;

    const selectedCalendarFare = getSelectedCalendarFare();
    const calendarPrice = parseMoney(selectedCalendarFare);
    const firstCardPrice = parseMoney(totalPrice(flights[0]));
    const evalKey = `${flights[0]?.id}-${firstCardPrice}-${calendarPrice}`;
    if (lastCheaperEvalRef.current === evalKey) return;
    lastCheaperEvalRef.current = evalKey;

    initialDealEvaluatedRef.current = true;

    if (selectedCalendarFare == null || selectedCalendarFare === "") {
      setCheaperPriceToastOpen(false);
      return;
    }

    applyCheaperPriceDeal(selectedCalendarFare, { scroll: true });
  }, [
    searchForFlights.loading,
    searchForFlights.data,
    searchForFlights.error,
    calendarLoading,
    data,
    nextDate,
    nextReturnDate,
  ]);

  //// handle Validate the flight
  const handeValidatFlight = (flight) => {
    const searchResults = searchForFlights?.data?.response;

    let validateNDCFlight = null;
    /// Check for NDC response to show the price of NDC

    const originFlight = searchParams.get("origin")?.split("~")[0];
    const destinationFlight = searchParams.get("destination")?.split("~")[
      searchParams.get("destination")?.split("~").length - 1
    ];

    const returnDate =
      searchParams.get("flight") === "Return"
        ? searchParams.get("return-date")
        : searchParams.get("departure-date")?.split("~")[
            searchParams.get("departure-date")?.split("~")?.length - 1
          ];

    const departureDate =
      searchParams.get("flight") === "Return"
        ? searchParams.get("departure-date")
        : searchParams.get("departure-date")?.split("~")[0];

    navigate("/booking/travelers-info", {
      state: {
        flight,
        ndcResponse: validateNDCFlight,
        source,
        prevPath: window.location.pathname + window.location.search,
        flightDetails: {
          return: searchParams.get("flight"),
          from: originFlight,
          to: destinationFlight,
          totalDays: moment(returnDate).diff(moment(departureDate), "days") + 1,

          returnDate:
            searchParams.get("flight") === "Return"
              ? searchParams.get("return-date")
              : searchParams.get("departure-date")?.split("~")[
                  searchParams.get("departure-date")?.split("~")?.length - 1
                ],
          departureDate:
            searchParams.get("flight") === "Return"
              ? searchParams.get("departure-date")
              : searchParams.get("departure-date")?.split("~")[0],
        },
        dictionaries: searchResults?.dictionaries,
        priceWithFare: totalPrice(flight),
        amaRefId,
        ...(searchParams.get("officeId") && {
          officeId: searchParams.get("officeId"),
        }),
        fareAdjustment:
          searchResults?.fareAdjustment &&
          searchResults?.fareAdjustment[flight?.id]
            ? searchResults?.fareAdjustment[flight?.id]
            : 0,
        ...(searchParams.get("packageDeal") === "1" && {
          packageDeal: true,
          packagePrice: roundPrice(searchParams.get("packagePrice") || "0"),
          packageCurrency: searchParams.get("packageCurrency") || "EUR",
          ...(searchParams.get("packageDealId") && {
            packageDealId: searchParams.get("packageDealId"),
          }),
          ...((searchParams.get("roomSingle") || searchParams.get("roomDouble") || searchParams.get("roomTriple") || searchParams.get("roomQuad")) && {
            packageRoomBreakdown: {
              single: parseInt(searchParams.get("roomSingle") || "0", 10),
              double: parseInt(searchParams.get("roomDouble") || "0", 10),
              triple: parseInt(searchParams.get("roomTriple") || "0", 10),
              quad: parseInt(searchParams.get("roomQuad") || "0", 10),
            },
          }),
        }),
      },
    });
    window.scrollTo(0, 0);
  };

  const handleExplore = (departureDate, returnDate) => {
    setSource("");
    setIncludedCarrierCodes([]);
    setAirlinesCodes([]);
    setDisabledSearch(false);
    setNaxtDate(departureDate);
    setNaxtReturnDate(returnDate);
  };

  const clearFilter = () => {
    filters.map((item) => {
      handleRemoveBadge(item);
    });
    setFilters([]);
    setAirlinesCodes([]);
    setIncludedCarrierCodes([]);
  };

  const updateFilter = () => {
    // Change the filter state based on the current filter
    const filter = [...filters];
    allFilters.map((mainFilter) => {
      const findChecked = mainFilter.options.find((i) => i.checked);
      if (findChecked) {
        filter.push(mainFilter);

        setFilters(filter);
      }
    });
  };

  const handleFilters = (currentFilter, remove) => {
    setSource("");
    const filter = [...filters];
    const findFilters = filter.find((i) => i.label === currentFilter.label);

    if (findFilters) {
      if (remove) {
        if (currentFilter.label === "Carrier Code") {
          const cleanFilter = filter.filter(
            (i) => i.label !== currentFilter.label
          );
          setFilters(cleanFilter);
        } else if (findFilters.multiple) {
          const checkIfAllOptionsDisabled = findFilters?.options.find(
            (i) => i.checked === true
          );
          if (!checkIfAllOptionsDisabled) {
            const cleanFilter = filter.filter(
              (i) => i.label !== currentFilter.label
            );
            setFilters(cleanFilter);
          }
        } else {
          const checkIfAllOptionsDisabled2 = findFilters?.options.find(
            (i) => i.checked
          );
          if (!checkIfAllOptionsDisabled2) {
            const cleanFilter = filter.filter(
              (i) => i.label !== currentFilter.label
            );
            setFilters(cleanFilter);
          }
        }
      }
    } else {
      filter.push(currentFilter);
      setFilters(filter);
    }
  };

  const handleUpdateFilters = (currentFilter, selectedOption) => {
    setDisabledSearch(false);

    const oldState = [...allFilters];
    const findOptionsOFFilter = allFilters.find(
      (filter) => filter.key === currentFilter.key
    )?.options;

    if (!findOptionsOFFilter) return; // Safety check

    let checkParam =
      typeof selectedOption.key === "boolean"
        ? !selectedOption.key
        : selectedOption.key;

    findOptionsOFFilter.forEach((item) => {
      if (item.value === selectedOption.value) {
        if (!currentFilter.key) {
          if (item.value === "Checked baggage") {
            searchParams.set("checkedbaggage", !item.checked);
          } else if (item.value === "2x Checked baggage") {
            const satyamValue = item.checked ? "PUBLISHED" : "NEGOTIATED";
            searchParams.set("satyamSpecial", satyamValue);
            checkParam = satyamValue;
          }
        }
        item.checked = !item.checked;
      } else if (currentFilter.key) {
        item.checked = false;
      }

      if (typeof selectedOption.key === "boolean") {
        item.key = checkParam;
      }
    });

    // Handle search param update for this filter
    if (currentFilter.key) {
      const existingValue = searchParams.get(currentFilter.key);
      if (existingValue === String(checkParam)) {
        searchParams.set(currentFilter.key, currentFilter.defaultOption);
      } else {
        searchParams.set(currentFilter.key, String(checkParam));
      }
    }

    // ✅ Correct way to update URL in react-router-dom@6.2.1
    navigate(`/search?${searchParams.toString()}`);

    setAllFilters(oldState);
    handleFilters(currentFilter, true);
  };

  const applyBaggageFilter = (optionValue) => {
    const baggageFilter = allFilters.find((filter) => filter.label === "Baggage");
    const option = baggageFilter?.options.find(
      (item) => item.value === optionValue,
    );

    if (!baggageFilter || !option) return;

    if (!option.checked) {
      handleUpdateFilters(baggageFilter, option);
    }
  };

  const handleChangeCarrier = (code) => {
    setDisabledSearch(false);

    if (includedCarrierCodes.includes(code)) {
      const codesFilters = includedCarrierCodes.filter((i) => i !== code);

      setIncludedCarrierCodes(codesFilters);
      if (codesFilters.length === 0) {
        handleFilters({ label: "Carrier Code" }, true);
      }
    } else {
      const codes = [...includedCarrierCodes];
      codes.push(code);
      setIncludedCarrierCodes(codes);
      handleFilters({ label: "Carrier Code" });
    }
  };

  const handleRemoveBadge = (currentFilter) => {
    if (currentFilter.label === "Carrier Code") {
      setIncludedCarrierCodes([]);
    } else {
      const oldState = [...allFilters];
      const findOptionsOFFilter = allFilters.find(
        (filter) => filter.key === currentFilter.key
      )?.options;

      if (!findOptionsOFFilter) return;

      findOptionsOFFilter.forEach((item) => {
        // Special case for baggage filters
        if (currentFilter.multiple && currentFilter.label === "Baggage") {
          searchParams.set("satyamSpecial", item.defaultOption || "");
          searchParams.set("checkedbaggage", "false");
        }

        item.checked = false;

        if (typeof item.key === "boolean") {
          item.key = false;
        }
      });

      // Update the filter state
      setAllFilters(oldState);

      // Reset the param
      if (currentFilter.key) {
        searchParams.set(currentFilter.key, currentFilter.defaultOption || "");
      }

      // Special case
      if (currentFilter.label === "Office ID") {
        searchParams.delete("officeId");
      }
      if (currentFilter.label === "Refundable Fare") {
        searchParams.delete("refundableFare");
      }
      if (currentFilter.label === "Stops") {
        searchParams.delete("stops");
      }

      // ✅ Correct navigation for react-router-dom@6.2.1
      navigate(`/search?${searchParams.toString()}`);
    }

    handleFilters(currentFilter, true);
  };

  //// GDS or NDC
  const handleSourceSearch = (source) => {
    setSource(source);
  };

  /// Get Carrier Logo
  const getCarrierLogo = (departureDate, returnDate) => {
    let logo;
    if (!returnDate) {
      logo =
        airlinesCodes[getPriceBasedOndepartureDate(departureDate)?.airline]
          ?.carrierLogo[0];
    } else {
      logo =
        airlinesCodes[
          getPriceBasedOndepartureAndReturnDate(departureDate, returnDate)
            ?.airline
        ]?.carrierLogo[0];
    }

    return logo?.squareImage ?? logo?.rectangleImage;
  };

  const handleOpenCommissionModal = (flight) => {
    searchForFlights.request({
      originDestinations: getFlightDestinations(),
      officeId: "AMSN222SH",

      ...{ source: "NDC" },
      ...(includedCarrierCodes?.length > 0 && { includedCarrierCodes }),
      ...commonParams,
    });
    if (flight?.source === "GDS") {
      setFlight(flight);
    }
    setOpen2(true);
  };

  useEffect(() => {
    const getNDCPriceForFlight = searchForFlights?.data?.response?.data?.find(
      (getFlight) => getFlight?.id === flight?.id
    );

    if (getNDCPriceForFlight?.source === "NDC") {
      setNdcPrice(getNDCPriceForFlight);
    } else {
      setNdcPrice();
    }
  }, [searchForFlights.data]);

  ///Adjust Prices

  const handleGetTheDestination = () => {
    const flights = [];
    const origins = searchParams.get("origin")?.split("~");
    const destinations = searchParams.get("destination")?.split("~");
    for (let i = 0; i < origins.length; i++) {
      const obj = {
        from: origins[i],
        to: destinations[i],
      };
      flights.push(obj);
    }
    return flights;
  };

  const componentRef = useRef();

  const [adjustedPrice, setAdjustedPrice] = useState(0);
  const [checked, setChecked] = useState(false);
  const [show, setShow] = useState(false);

  const handleSellingForSurinamePrice = () => {
    //USD 1.5
    //EUR 2.5
    let markupPercentage = 0;

    if (currency?.sign?.trim() === "€") {
      markupPercentage = 2.5;
    }
    const checkIfSellingEdited = adjustedPrice
      ? +adjustedPrice
      : +totalPrice(selectedFlight);
    const getPricePercentage = (checkIfSellingEdited * markupPercentage) / 100;

    const newPrice = (checkIfSellingEdited + getPricePercentage)?.toFixed(2);

    if (checked) return Math.ceil(newPrice);

    return null;
  };

  const extractIataCode = (value) => {
    if (!value) return "";
    const raw = String(value).split("~")[0].trim();
    const match = raw.match(/^[A-Za-z]{3}/);
    return match ? match[0].toUpperCase() : "";
  };

  const downloadScreenshot = (flightToCapture) => {
    if (!flightToCapture) return;
    setSelectedFlight(flightToCapture);
    setShow(true);
  };

  useEffect(() => {
    if (!show || !selectedFlight) return undefined;

    let cancelled = false;
    const timer = window.setTimeout(async () => {
      if (cancelled || !componentRef.current) return;

      const routes = handleGetTheDestination();
      const originCode = extractIataCode(routes[0]?.from);
      const destinationCode = extractIataCode(routes[routes.length - 1]?.to);
      const originDateFromURL = searchParams.get("departure-date");
      const returnDateFromURL = searchParams.get("return-date");
      const carrier =
        selectedFlight?.itineraries?.[0]?.segments?.[0]?.carrierCode ||
        "flight";

      const formattedFileName = `${carrier}-${originCode || "XXX"}-${
        destinationCode || "XXX"
      }-${moment(originDateFromURL?.split("~")[0]).format("DMMM")}${
        searchParams.get("flight") === "Multi-city"
          ? `-${moment(
              originDateFromURL?.split("~")[
                originDateFromURL?.split("~")?.length - 1
              ]
            ).format("DMMM")}`
          : searchParams.get("flight") === "Return" && returnDateFromURL
            ? `-${moment(
                returnDateFromURL?.split("~")[
                  returnDateFromURL?.split("~")?.length - 1
                ]
              ).format("DMMM")}`
            : ""
      }`;

      try {
        const dataUrl = await toPng(componentRef.current, {
          cacheBust: true,
          pixelRatio: 2,
          backgroundColor: "#ffffff",
        });
        if (cancelled) return;
        const link = document.createElement("a");
        link.download = `${formattedFileName}.png`;
        link.href = dataUrl;
        document.body.appendChild(link);
        link.click();
        link.remove();
      } catch (error) {
        console.error("Share quote failed", error);
      } finally {
        if (!cancelled) setShow(false);
      }
    }, 400);

    return () => {
      cancelled = true;
      window.clearTimeout(timer);
    };
  }, [show, selectedFlight]);

  // Shared between the desktop sidebar and the mobile filter drawer
  const filterPanelContent = (
    <>
      {filters?.length > 0 && (
        <Box className="search-form-filter__active" my={1}>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            className="search-form-filter__active-header"
          >
            <p className="bolder">
              {t("search.filterActive", { count: filters?.length })}
            </p>
            <Button
              onClick={clearFilter}
              className="active-filter search-form-filter__clear"
            >
              {t("search.clearFilter")}
            </Button>
          </Box>
          <Box
            display="flex"
            my={1}
            alignItems="center"
            flexWrap="wrap"
            className="search-form-filter__badges"
          >
            {filters?.map((filter, index) => (
              <Badge
                key={index}
                className="teal"
                title={filter?.labelKey ? t(filter.labelKey) : filter?.label}
                iconClose
                onCloseClick={() => handleRemoveBadge(filter)}
              />
            ))}
          </Box>
        </Box>
      )}

      {allFilters?.map((filter, index) =>
        !filter?.permission ? (
          <FilterCollapse
            key={index}
            headerTitle={filter.labelKey ? t(filter.labelKey) : filter.label}
            collapseChildren={filter.options}
            onChange={(optionSelected) =>
              handleUpdateFilters(filter, optionSelected)
            }
          />
        ) : (
          checkISAdminOrEmployee() && (
            <FilterCollapse
              key={index}
              headerTitle={filter.labelKey ? t(filter.labelKey) : filter.label}
              collapseChildren={filter.options}
              onChange={(optionSelected) =>
                handleUpdateFilters(filter, optionSelected)
              }
            />
          )
        )
      )}
      {airlinesCodes && Object.keys(airlinesCodes)?.length > 0 && (
        <FilterCollapse
          headerTitle={t("search.airlineCarriers")}
          collapseChildren={Object.keys(airlinesCodes)}
          onChange={handleChangeCarrier}
          includedCarrierCodes={includedCarrierCodes}
          hasImg
          airlineCarrier={airlinesCodes}
        />
      )}
    </>
  );

  return (
    <>
      <div className="search-form-wrapper">
        <div className="search-form banner">
          {!isSearchFormOpen && (
            <div className="search-summary">
              <button
                type="button"
                className="search-summary__main"
                onClick={() => setIsSearchFormOpen(true)}
                aria-expanded={false}
              >
                <div className="search-summary__route">
                  <div className="search-summary__city">
                    <span className="search-summary__code">
                      {searchSummary.origin.code}
                    </span>
                    {searchSummary.origin.name ? (
                      <span className="search-summary__name">
                        {searchSummary.origin.name}
                      </span>
                    ) : null}
                  </div>
                  <span className="search-summary__plane" aria-hidden="true">
                    <Airplate />
                  </span>
                  <div className="search-summary__city">
                    <span className="search-summary__code">
                      {searchSummary.destination.code}
                    </span>
                    {searchSummary.destination.name ? (
                      <span className="search-summary__name">
                        {searchSummary.destination.name}
                      </span>
                    ) : null}
                  </div>
                </div>

                <div className="search-summary__meta">
                  {searchSummary.dateLabel ? (
                    <span className="search-summary__chip">
                      {searchSummary.dateLabel}
                    </span>
                  ) : null}
                  <span className="search-summary__chip">
                    {searchSummary.tripLabel}
                  </span>
                  <span className="search-summary__chip">
                    {searchSummary.cabinLabel}
                  </span>
                  <span className="search-summary__chip search-summary__chip--people">
                    <PeopleAltOutlinedIcon />
                    {searchSummary.travelerCount === 1
                      ? t("search.traveler", {
                          count: searchSummary.travelerCount,
                        })
                      : t("search.travelers", {
                          count: searchSummary.travelerCount,
                        })}
                  </span>
                </div>
              </button>

              <button
                type="button"
                className="search-summary__modify"
                onClick={() => setIsSearchFormOpen(true)}
              >
                <EditOutlinedIcon />
                <span>{t("search.modifySearch")}</span>
              </button>
            </div>
          )}

          <Collapse in={isSearchFormOpen} timeout={220} unmountOnExit>
            <div className="search-form__editor">
              <div className="search-form__editor-header">
                <p>{t("search.modifySearch")}</p>
                <button
                  type="button"
                  className="search-form__editor-close"
                  onClick={() => setIsSearchFormOpen(false)}
                  aria-label={t("search.closeSearch")}
                >
                  <CloseRoundedIcon />
                  <span>{t("search.closeSearch")}</span>
                </button>
              </div>
              <Banner
                activeBtn
                compact
                departureDate={departureDate}
                setdepartureDate={setdepartureDate}
                returnDate={returnDate}
                setReturnDate={setReturnDate}
                handleExplore={handleExplore}
                hideFilter
                airlinesCodes={airlinesCodes && Object.keys(airlinesCodes)}
                airlineCarrier={airlinesCodes}
                onChangeCarrier={handleChangeCarrier}
                includedCarrierCodes={includedCarrierCodes}
                handleFilters={handleFilters}
                allFilters={allFilters}
                setAllFilters={setAllFilters}
                setRedirectLink={setRedirectLink}
                loading={searchForFlights.loading}
              />
            </div>
          </Collapse>
        </div>

        <div className="search-results-wrapper">
          <div className="search-results-view">
            <div className="search-results-container">
              <div className="search-form-filter">
                <div className="search-form-filter__panel">
                  <div className="search-form-filter__heading">
                    <p>{t("banner.filters")}</p>
                  </div>

                  {filterPanelContent}
                </div>
              </div>
              <div className="search-results-list">
                {filters?.length > 0 && (
                  <div className="show-mobile horizontal-menu-parent">
                    <div className="horizontal-menu-child">
                      <ScrollMenu LeftArrow={LeftArrow} RightArrow={RightArrow}>
                        {filters?.map((filter, index) => (
                          <Button key={index}>
                            {filter?.labelKey ? t(filter.labelKey) : filter?.label}
                          </Button>
                        ))}
                        <Button
                          onClick={clearFilter}
                          className="primary-color mx-2"
                        >
                          {t("search.clearFilter")}
                        </Button>
                      </ScrollMenu>
                    </div>
                  </div>
                )}

                {!calendarErr &&
                  searchParams.get("origin")?.split("~").length < 3 && (
                    <div className="price-tabel">
                      <div
                        className="price-tabel-title mobile-show"
                        onClick={toggleDrawer(true)}
                      >
                        <div className="price-tabel-title__main">
                          <span className="price-tabel-title__icon">
                            <CalPrice />
                          </span>
                          <div>
                            <p className="bolder">
                              {t("search.pricingTable")}
                            </p>
                            <span className="price-tabel-title__hint">
                              {t("search.pricingTableHint")}
                            </span>
                          </div>
                        </div>
                        <ExpandMore />
                      </div>
                      <div
                        className={
                          openPriTable
                            ? "price-tabel-title desktop-show active"
                            : "price-tabel-title desktop-show"
                        }
                        onClick={() => setOpenPriTable(!openPriTable)}
                      >
                        <div className="price-tabel-title__main">
                          <span className="price-tabel-title__icon">
                            <CalPrice />
                          </span>
                          <div>
                            <p className="bolder">
                              {t("search.pricingTable")}
                            </p>
                            <span className="price-tabel-title__hint">
                              {t("search.pricingTableHint")}
                            </span>
                          </div>
                        </div>
                        {openPriTable ? <ExpandLess /> : <ExpandMore />}
                      </div>

                      <Collapse
                        className="desktop-show"
                        in={openPriTable}
                        timeout="auto"
                        unmountOnExit
                        sx={{ minHeight: "210px" }}
                      >
                        <div className="price-tabel__toolbar">
                          <div className="price-tabel__nav">
                            <div className="flex-depart">
                              <Button
                                onClick={handlePreviousCalendarBtn}
                                disabled={!canGoPreviousDeparture}
                                data-cy="d-arrow-previous"
                              >
                                <ArrowDown />
                              </Button>
                              <Button
                                data-cy="d-arrow-next"
                                onClick={handleNextCalendarBtn}
                                disabled={!canGoNextDeparture}
                              >
                                <ArrowDown />
                              </Button>
                              <p className="small-font-size bold">
                                {getTravelRange(
                                  t("search.departure"),
                                  departureDates
                                )}
                              </p>
                            </div>
                            {searchParams.get("flight") !== "One-way" && (
                              <div className="flex-depart">
                                <Button
                                  onClick={handlePreviousReturnCalendarBtn}
                                  disabled={!canGoPreviousReturn}
                                  data-cy="r-arrow-previous"
                                >
                                  <ArrowDown />
                                </Button>
                                <Button
                                  onClick={handleNextReturnCalendarBtn}
                                  data-cy="r-arrow-next"
                                >
                                  <ArrowDown />
                                </Button>
                                <p className="small-font-size bold">
                                  {getTravelRange(
                                    t("search.return"),
                                    returnDates
                                  )}
                                </p>
                              </div>
                            )}
                          </div>
                          <div className="price-tabel__legend">
                            <span className="price-tabel__legend-item is-cheap">
                              {t("search.pricingCheaper")}
                            </span>
                            <span className="price-tabel__legend-item is-expensive">
                              {t("search.pricingHigher")}
                            </span>
                          </div>
                        </div>

                        <div className="price-tabel__disclaimer">
                          <span className="price-tabel__disclaimer-badge">
                            {t("search.pricingTip")}
                          </span>
                          <p>{t("search.pricingDisclaimer")}</p>
                        </div>

                        <div className="date-calendar-table">
                          <div className="date-cells-wrapper">
                            {departureDates.map((departureDate, index) => {
                              const focus = getCalendarFocusIndices();
                              return (
                                <div
                                  key={index}
                                  className={`date-cell${
                                    index === focus.departure
                                      ? " is-active"
                                      : ""
                                  }`}
                                  style={{
                                    width:
                                      searchParams.get("flight") !== "One-way"
                                        ? "12%"
                                        : "15%",
                                  }}
                                >
                                  {formatDateToMoment(departureDate)}
                                </div>
                              );
                            })}
                          </div>
                          <div className="date-calendar-container">
                            {calendarLoading
                              ? [
                                  ...Array(
                                    searchParams.get("flight") !== "One-way"
                                      ? 7
                                      : 8
                                  ),
                                ].map((_, index) => (
                                  <div
                                    key={index}
                                    style={{
                                      width:
                                        searchParams.get("flight") !== "One-way"
                                          ? "12%"
                                          : "15%",
                                    }}
                                    className="date-cells-wrapper right-side"
                                  >
                                    {[...Array(7)].map((_, index) => (
                                      <Skeleton
                                        key={index}
                                        variant="rounded"
                                        height="50px"
                                        width="98%"
                                        className="price-cell"
                                        animation="wave"
                                        sx={{ bgcolor: "#F1F3F6" }}
                                      />
                                    ))}
                                  </div>
                                ))
                              : searchParams.get("flight") !== "One-way"
                              ? departureDates?.map(
                                  (departureDate, departureIndex) => (
                                    <div
                                      className="date-cells-wrapper right-side"
                                      key={departureIndex}
                                    >
                                      {returnDates.map(
                                        (returnDate, returnIndex) => {
                                          const price =
                                            getPriceBasedOndepartureAndReturnDate(
                                              departureDate,
                                              returnDate
                                            )?.price;

                                          return (
                                            <div
                                              key={returnIndex}
                                              onMouseLeave={clearCalendarHover}
                                              onMouseEnter={() => {
                                                if (!price) return;
                                                setActivePrice({
                                                  return: returnIndex,
                                                  departure: departureIndex,
                                                });
                                              }}
                                              onClick={() => {
                                                handleFlightOptionClick(
                                                  departureDate,
                                                  returnDate,
                                                  price
                                                );
                                              }}
                                              style={{
                                                pointerEvents: price
                                                  ? "all"
                                                  : "none",
                                                cursor: price
                                                  ? "pointer"
                                                  : "default",
                                              }}
                                              className={getReturnMatrixCellClass(
                                                departureDate,
                                                returnDate,
                                                departureIndex,
                                                returnIndex,
                                                price
                                              )}
                                            >
                                              {price ? (
                                                <div className="price-cell__content">
                                                  <span className="price-cell__logo">
                                                    <Tooltip
                                                      title={
                                                        airlinesCodes[
                                                          getPriceBasedOndepartureAndReturnDate(
                                                            departureDate,
                                                            returnDate
                                                          )?.airline
                                                        ]?.carrierName
                                                          ? capitalizeFirstLetter(
                                                              airlinesCodes[
                                                                getPriceBasedOndepartureAndReturnDate(
                                                                  departureDate,
                                                                  returnDate
                                                                )?.airline
                                                              ]?.carrierName
                                                            )
                                                          : ""
                                                      }
                                                      arrow
                                                      placement="top"
                                                    >
                                                      <img
                                                        id="flight-logo-calendar"
                                                        src={getCarrierLogo(
                                                          departureDate,
                                                          returnDate
                                                        )}
                                                        alt=""
                                                      />
                                                    </Tooltip>
                                                  </span>
                                                  <span className="price-cell__price">
                                                    {currency?.sign}
                                                    {price}
                                                  </span>
                                                </div>
                                              ) : null}
                                            </div>
                                          );
                                        }
                                      )}
                                    </div>
                                  )
                                )
                              : departureDates?.map(
                                  (departureDate, departureIndex) => {
                                    const price =
                                      getPriceBasedOndepartureDate(
                                        departureDate
                                      )?.price;

                                    return (
                                      <div
                                        className="date-cells-wrapper right-side"
                                        key={departureIndex}
                                        style={{
                                          width: "15%",
                                        }}
                                      >
                                        <div
                                          className={getOneWayCellClass(
                                            departureDate,
                                            price
                                          )}
                                          style={{
                                            cursor: price
                                              ? "pointer"
                                              : "default",
                                            pointerEvents: price
                                              ? "all"
                                              : "none",
                                          }}
                                          onClick={() => {
                                            handleFlightOptionClick(
                                              moment(departureDate).format(
                                                "YYYY-MM-DD"
                                              ),
                                              undefined,
                                              price
                                            );
                                          }}
                                        >
                                          {price ? (
                                            <div className="price-cell__content">
                                              <span className="price-cell__logo">
                                                <Tooltip
                                                  title={
                                                    airlinesCodes[
                                                      getPriceBasedOndepartureDate(
                                                        departureDate
                                                      )?.airline
                                                    ]?.carrierName
                                                      ? capitalizeFirstLetter(
                                                          airlinesCodes[
                                                            getPriceBasedOndepartureDate(
                                                              departureDate
                                                            )?.airline
                                                          ]?.carrierName
                                                        )
                                                      : ""
                                                  }
                                                  arrow
                                                  placement="top"
                                                >
                                                  <img
                                                    id="flight-logo-calendar"
                                                    src={getCarrierLogo(
                                                      departureDate
                                                    )}
                                                    alt=""
                                                  />
                                                </Tooltip>
                                              </span>
                                              <span className="price-cell__price">
                                                {currency?.sign}
                                                {price}
                                              </span>
                                            </div>
                                          ) : null}
                                        </div>
                                      </div>
                                    );
                                  }
                                )}
                            {searchParams.get("flight") !== "One-way" && (
                              <div className="date-cells-wrapper right-side">
                                {returnDates.map((returnDate, index) => {
                                  const focus = getCalendarFocusIndices();
                                  return (
                                    <div
                                      className={`date-cell${
                                        index === focus.return
                                          ? " is-active"
                                          : ""
                                      }`}
                                      key={index}
                                    >
                                      {formatDateToMoment(returnDate)}
                                    </div>
                                  );
                                })}
                              </div>
                            )}
                          </div>
                        </div>
                      </Collapse>
                    </div>
                  )}

                <button
                  type="button"
                  className="mobile-filter-trigger"
                  onClick={() => setOpenMobileFilter(true)}
                >
                  <TuneRoundedIcon />
                  <span>{t("banner.filters")}</span>
                  {filters?.length > 0 && (
                    <span className="mobile-filter-trigger__count">
                      {filters.length}
                    </span>
                  )}
                </button>

                {searchForFlights.loading ? (
                  <div className="card-card d-flex skeleton-search card-wrapper">
                    <div className="circle-card one"></div>
                    <div className="circle-card two"></div>
                    <div className="circle-card three"></div>
                    <div className="circle-card four"></div>
                    <div className="skeleton-search-left">
                      <Skeleton
                        variant="text"
                        width={"40%"}
                        height={30}
                        animation="wave"
                        sx={{ bgcolor: "#F1F3F6", marginBottom: 1 }}
                      />
                      <Skeleton
                        variant="rectangular"
                        width={"100%"}
                        height={100}
                        sx={{
                          marginBottom: 3,
                          bgcolor: "#F1F3F6",
                          borderRadius: "4px",
                        }}
                        animation="wave"
                      />
                      <Skeleton
                        variant="text"
                        width={"40%"}
                        height={30}
                        sx={{
                          marginBottom: 1,
                          bgcolor: "#F1F3F6",
                          borderRadius: "4px",
                        }}
                        animation="wave"
                      />
                      <Skeleton
                        variant="rectangular"
                        width={"100%"}
                        height={100}
                        sx={{
                          marginBottom: 1,
                          bgcolor: "#F1F3F6",
                          borderRadius: "4px",
                        }}
                        animation="wave"
                      />
                    </div>
                    <div className="skeleton-search-right">
                      <Skeleton
                        variant="rectangular"
                        width={"90%"}
                        height={100}
                        sx={{
                          marginBottom: 3,
                          bgcolor: "#F1F3F6",
                          borderRadius: "4px",
                        }}
                        animation="wave"
                      />
                      <Skeleton
                        variant="rectangular"
                        width={"90%"}
                        height={30}
                        sx={{
                          marginBottom: 1,
                          bgcolor: "#F1F3F6",
                          borderRadius: "4px",
                        }}
                        animation="wave"
                      />
                    </div>
                  </div>
                ) : searchForFlights?.error ||
                  searchForFlights?.data?.response?.data?.length === 0 ? (
                  <div className="search-empty">
                    <span className="search-empty__icon" aria-hidden="true">
                      <Iconify icon="mdi:airplane-search" width={32} />
                    </span>
                    <h2 className="search-empty__title">
                      {t("search.noFlights")}
                    </h2>
                    <p className="search-empty__hint">
                      {t("search.noFlightsHint")}
                    </p>
                    <div className="search-empty__tips">
                      <span>{t("search.noFlightsTipDate")}</span>
                      <span>{t("search.noFlightsTipStop")}</span>
                      <span>{t("search.noFlightsTipFilters")}</span>
                    </div>
                    <button
                      type="button"
                      className="search-empty__cta"
                      onClick={() => setIsSearchFormOpen(true)}
                    >
                      {t("search.modifySearch")}
                    </button>
                  </div>
                ) : (
                  <>
                    {searchParams.get("packageDeal") === "1" && (
                      <Alert
                        severity="info"
                        sx={{ mb: 2 }}
                        icon={
                          <Box
                            component="span"
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              "& svg": { fontSize: 20 },
                            }}
                          >
                            ✈️
                          </Box>
                        }
                      >
                        <strong>{t("search.packageDealTitle")}</strong> —{" "}
                        {t("search.packageDealDescription", {
                          price: `${currency?.sign}${roundPrice(
                            searchParams.get("packagePrice") || 0
                          ).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}`,
                        })}
                      </Alert>
                    )}
                    {searchForFlights?.data?.response?.data?.map(
                      (flight, index) => (
                        <div
                          key={flight?.id || index}
                          ref={index === 0 ? firstResultCardRef : null}
                        >
                        <ResultCard
                          handeValidatFlight={handeValidatFlight}
                          onApplyBaggageFilter={applyBaggageFilter}
                          originLocationCode={searchParams.get("origin")}
                          destinationLocationCode={searchParams.get(
                            "destination"
                          )}
                          flight={flight}
                          dictionaries={
                            searchForFlights?.data?.response?.dictionaries
                          }
                          flightSearchCriteria={{
                            originDestinations: getFlightDestinations(),
                            ...commonParams,
                            includedCheckedBagsOnly:
                              searchParams.get("checkedbaggage") === "true",
                            refundableFare:
                              searchParams.get("refundableFare") === "true",
                          }}
                          totalPrice={totalPrice}
                          handleSourceSearch={handleSourceSearch}
                          source={source}
                          currency={currency?.sign}
                          cardID={searchParams.get("cardNum")}
                          returnDate={
                            searchParams.get("flight") === "Return"
                              ? searchParams.get("return-date")
                              : searchParams.get("departure-date")?.split("~")[
                                  searchParams.get("departure-date")?.split("~")
                                    ?.length - 1
                                ]
                          }
                          departurDate={
                            searchParams.get("flight") === "Return"
                              ? searchParams.get("departure-date")
                              : searchParams
                                  .get("departure-date")
                                  ?.split("~")[0]
                          }
                          flightType={searchParams.get("flight")}
                          officeId={searchParams.get("officeId")}
                          searchWithNDC={searchWithNDC}
                          setSearchWithNDC={setSearchWithNDC}
                          handleOpenCommissionModal={() => {
                            handleOpenCommissionModal();
                            setFlight(flight);
                          }}
                          getSelectedFLight={setSelectedFlight}
                          setAdjustedPrice={setAdjustedPrice}
                          adjustedPrice={adjustedPrice}
                          checked={checked}
                          setChecked={setChecked}
                          handlePrintComponent={() =>
                            downloadScreenshot(flight)
                          }
                          hasSale={flight?.source === "NDC" || flight.isWebFare}
                          itineraries={handleGetTheDestination()}
                          getSellingForSurinamePrice={
                            handleSellingForSurinamePrice
                          }
                          packageDeal={searchParams.get("packageDeal") === "1"}
                          packagePrice={
                            searchParams.get("packageDeal") === "1"
                              ? roundPrice(searchParams.get("packagePrice") || "0")
                              : null
                          }
                        />
                        </div>
                      )
                    )}
                  </>
                )}
              </div>
              {/* <VirtualReality /> */}
              <SideBar
                isTwoCheckedBaggageRoute={isTwoCheckedBaggageRoute}
                isTwoCheckedBaggageActive={allFilters
                  .find((filter) => filter.label === "Baggage")
                  ?.options?.some(
                    (item) =>
                      item.value === "2x Checked baggage" && item.checked
                  )}
                onApplyTwoCheckedBaggage={() =>
                  applyBaggageFilter("2x Checked baggage")
                }
              />
            </div>
          </div>
        </div>
      </div>

      <ModalCom
        className="mobile-filter-drawer"
        toggleDrawer={(open) => () => setOpenMobileFilter(open)}
        openDrawer={openMobileFilter}
      >
        <div className="mobile-filter-drawer__header">
          <p>{t("banner.filters")}</p>
          <button
            type="button"
            className="mobile-filter-drawer__close"
            onClick={() => setOpenMobileFilter(false)}
            aria-label={t("common.cancel")}
          >
            <CloseRoundedIcon />
          </button>
        </div>

        <div className="mobile-filter-drawer__scroll search-form-filter">
          <div className="search-form-filter__panel">{filterPanelContent}</div>
        </div>

        <div className="mobile-filter-drawer__footer">
          <Button
            className="primary-color w-100"
            onClick={() => setOpenMobileFilter(false)}
          >
            {t("common.done")}
          </Button>
        </div>
      </ModalCom>

      <ModalCom
        className={`
        full-size-modal tabel-price
       `}
        toggleDrawer={toggleDrawer}
        sx={{ "& .MuiPaper-root": { overflow: "hidden " } }}
        openDrawer={
          openDrawer ||
          (!closePriceModal &&
            searchForFlights?.data?.response?.data?.length === 0 &&
            window.innerWidth < 768)
        }
      >
        <div className="modal-tilte">
          <div className="price-tabel-title__main">
            <span className="price-tabel-title__icon">
              <CalPrice />
            </span>
            <div>
              <p className="bolder">{t("search.pricingTableTitle")}</p>
              <span className="price-tabel-title__hint">
                {t("search.pricingTableHint")}
              </span>
            </div>
          </div>
        </div>
        <div className="price-tabel__disclaimer is-mobile">
          <span className="price-tabel__disclaimer-badge">
            {t("search.pricingTip")}
          </span>
          <p>{t("search.pricingDisclaimer")}</p>
        </div>
        <div className="mobile-price-matrix">
          <div className="mobile-price-matrix__toolbars">
            <div className="flex-depart mobile-price-matrix__toolbar">
              <Button
                onClick={handlePreviousCalendarBtn}
                disabled={!canGoPreviousDeparture}
                data-cy="d-arrow-previous"
              >
                <ArrowDown />
              </Button>
              <Button
                data-cy="d-arrow-next"
                onClick={handleNextCalendarBtn}
                disabled={!canGoNextDeparture}
              >
                <ArrowDown />
              </Button>
              <p className="small-font-size bold">
                {getTravelRange(t("search.departure"), departureDates)}
              </p>
            </div>

            {searchParams.get("flight") !== "One-way" && (
              <div className="flex-depart mobile-price-matrix__toolbar is-return">
                <Button
                  onClick={handlePreviousReturnCalendarBtn}
                  disabled={!canGoPreviousReturn}
                  data-cy="r-arrow-previous"
                >
                  <ArrowDown />
                </Button>
                <Button
                  onClick={handleNextReturnCalendarBtn}
                  data-cy="r-arrow-next"
                >
                  <ArrowDown />
                </Button>
                <p className="small-font-size bold">
                  {getTravelRange(t("search.return"), returnDates)}
                </p>
              </div>
            )}

            <div className="price-tabel__legend">
              <span className="price-tabel__legend-item is-cheap">
                {t("search.pricingCheaper")}
              </span>
              <span className="price-tabel__legend-item is-expensive">
                {t("search.pricingHigher")}
              </span>
            </div>
          </div>

          <div className="mobile-price-matrix__scroll">
            {calendarLoading ? (
              <div
                className={`mobile-price-matrix__grid${
                  searchParams.get("flight") === "One-way"
                    ? " is-one-way"
                    : ""
                }`}
                style={{ "--mobile-matrix-cols": 7 }}
              >
                <div className="mobile-price-matrix__corner" />
                {[...Array(7)].map((_, index) => (
                  <Skeleton
                    key={`dep-skel-${index}`}
                    variant="rounded"
                    className="date-cell"
                    height={34}
                    animation="wave"
                    sx={{ bgcolor: "#F1F3F6", width: "100%", margin: 0 }}
                  />
                ))}
                {[...Array(searchParams.get("flight") === "One-way" ? 1 : 7)].map(
                  (_, rowIndex) => (
                    <React.Fragment key={`row-skel-${rowIndex}`}>
                      <Skeleton
                        variant="rounded"
                        className="date-cell mobile-price-matrix__row-label"
                        height={48}
                        animation="wave"
                        sx={{ bgcolor: "#F1F3F6", width: "100%", margin: 0 }}
                      />
                      {[...Array(7)].map((_, colIndex) => (
                        <Skeleton
                          key={`cell-skel-${rowIndex}-${colIndex}`}
                          variant="rounded"
                          className="price-cell"
                          height={48}
                          animation="wave"
                          sx={{ bgcolor: "#F1F3F6", width: "100%", margin: 0 }}
                        />
                      ))}
                    </React.Fragment>
                  )
                )}
              </div>
            ) : searchParams.get("flight") === "One-way" ? (
              <div
                className="mobile-price-matrix__grid is-one-way"
                style={{
                  "--mobile-matrix-cols": Math.max(departureDates.length, 1),
                }}
              >
                <div className="mobile-price-matrix__corner" />
                {departureDates.map((departureDate, index) => {
                  const focus = getCalendarFocusIndices();
                  return (
                    <div
                      key={`dep-${index}`}
                      className={`date-cell${
                        index === focus.departure ? " is-active" : ""
                      }`}
                    >
                      {formatDateToMoment(departureDate)}
                    </div>
                  );
                })}
                <div className="date-cell mobile-price-matrix__row-label">
                  {t("search.departure")}
                </div>
                {departureDates.map((departureDate, departureIndex) => {
                  const price =
                    getPriceBasedOndepartureDate(departureDate)?.price;

                  return (
                    <div
                      key={`oneway-${departureIndex}`}
                      className={getOneWayCellClass(departureDate, price)}
                      style={{
                        cursor: price ? "pointer" : "default",
                        pointerEvents: price ? "all" : "none",
                      }}
                      onClick={() => {
                        handleFlightOptionClick(
                          moment(departureDate).format("YYYY-MM-DD"),
                          undefined,
                          price
                        );
                        setOpenDrawer(false);
                      }}
                    >
                      {price ? (
                        <div className="price-cell__content">
                          <span className="price-cell__logo">
                            <img
                              id="flight-logo-calendar"
                              src={getCarrierLogo(departureDate)}
                              alt=""
                            />
                          </span>
                          <span className="price-cell__price">
                            {currency?.sign}
                            {price}
                          </span>
                        </div>
                      ) : null}
                    </div>
                  );
                })}
              </div>
            ) : (
              <div
                className="mobile-price-matrix__grid"
                style={{
                  "--mobile-matrix-cols": Math.max(departureDates.length, 1),
                }}
              >
                <div className="mobile-price-matrix__corner" />
                {departureDates.map((departureDate, index) => {
                  const focus = getCalendarFocusIndices();
                  return (
                    <div
                      key={`dep-${index}`}
                      className={`date-cell${
                        index === focus.departure ? " is-active" : ""
                      }`}
                    >
                      {formatDateToMoment(departureDate)}
                    </div>
                  );
                })}

                {returnDates.map((returnDate, returnIndex) => {
                  const focus = getCalendarFocusIndices();
                  return (
                    <React.Fragment key={`return-row-${returnIndex}`}>
                      <div
                        className={`date-cell mobile-price-matrix__row-label${
                          returnIndex === focus.return ? " is-active" : ""
                        }`}
                      >
                        {formatDateToMoment(returnDate)}
                      </div>
                      {departureDates.map((departureDate, departureIndex) => {
                        const price =
                          getPriceBasedOndepartureAndReturnDate(
                            departureDate,
                            returnDate
                          )?.price;

                        return (
                          <div
                            key={`cell-${departureIndex}-${returnIndex}`}
                            onMouseLeave={clearCalendarHover}
                            onMouseEnter={() => {
                              if (!price) return;
                              setActivePrice({
                                return: returnIndex,
                                departure: departureIndex,
                              });
                            }}
                            onClick={() => {
                              handleFlightOptionClick(
                                departureDate,
                                returnDate,
                                price
                              );
                              setOpenDrawer(false);
                            }}
                            style={{
                              pointerEvents: price ? "all" : "none",
                              cursor: price ? "pointer" : "default",
                            }}
                            className={getReturnMatrixCellClass(
                              departureDate,
                              returnDate,
                              departureIndex,
                              returnIndex,
                              price
                            )}
                          >
                            {price ? (
                              <div className="price-cell__content">
                                <span className="price-cell__logo">
                                  <img
                                    id="flight-logo-calendar"
                                    src={getCarrierLogo(
                                      departureDate,
                                      returnDate
                                    )}
                                    alt=""
                                  />
                                </span>
                                <span className="price-cell__price">
                                  {currency?.sign}
                                  {price}
                                </span>
                              </div>
                            ) : null}
                          </div>
                        );
                      })}
                    </React.Fragment>
                  );
                })}
              </div>
            )}
          </div>
        </div>

        <div className="modal-footer">
          <Button className="w-100" onClick={toggleDrawer(false)}>
            {t("common.cancel")}
          </Button>
          {/* <Button className="primary-color w-100">Select</Button> */}
        </div>
      </ModalCom>
      <Modal
        open={openPop}
        // onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div className="pop-up-modal">
          {loading ? (
            <>
              <p className="main-title">
                {t("search.checkingAvailability")}
              </p>
              <LinearProgress sx={{ backgroundColor: "#edcfa7" }} />
            </>
          ) : (
            <>
              <p className="main-title">{t("search.unavailable")}</p>
              <div className="footer-popup">
                <Button onClick={() => setOpenPop(false)}>
                  {t("common.cancel")}
                </Button>
                <Button
                  onClick={() => {
                    setOpenPop(false);
                    window.location.reload();
                  }}
                  className="primary-color"
                >
                  {t("common.refresh")}
                </Button>
              </div>
            </>
          )}
        </div>
      </Modal>

      <CommissionModal
        getNdcPrice={ndcPrice}
        flight={flight}
        open={open2}
        setOpen={setOpen2}
        loading={searchForFlights.loading}
        fareAdjustment={
          searchForFlights?.data?.response?.fareAdjustment &&
          searchForFlights?.data?.response?.fareAdjustment[flight?.id]
            ? searchForFlights?.data?.response?.fareAdjustment[flight?.id]
            : 0
        }
      />

      {show && selectedFlight && (
        <Box
          sx={{
            position: "fixed",
            top: -9999,
            left: -9999,
            width: 580,
            pointerEvents: "none",
            zIndex: -1,
          }}
        >
          <Box ref={componentRef} sx={{ width: 580 }}>
            <ShareQuatePrice
              flight={selectedFlight}
              dictionaries={searchForFlights?.data?.response?.dictionaries}
              adjustedPrice={adjustedPrice}
              destinationLocationCode={extractIataCode(
                searchParams.get("destination")?.split("~").slice(-1)[0]
              )}
              originLocationCode={extractIataCode(searchParams.get("origin"))}
              totalPrice={totalPrice}
              currency={currency?.sign}
              getSellingForSurinamePrice={handleSellingForSurinamePrice}
              checked={checked}
              packageDeal={searchParams.get("packageDeal") === "1"}
              packagePrice={
                searchParams.get("packageDeal") === "1"
                  ? roundPrice(searchParams.get("packagePrice") || "0")
                  : null
              }
              daysNumber={
                searchParams.get("flight") === "Return"
                  ? moment(searchParams.get("return-date")).diff(
                      moment(searchParams.get("departure-date")),
                      "days"
                    ) + 1
                  : null
              }
              fareAdjustment={
                searchForFlights?.data?.response?.fareAdjustment
              }
            />
          </Box>
        </Box>
      )}

      <Snackbar
        open={cheaperPriceToastOpen}
        autoHideDuration={4500}
        onClose={(_, reason) => {
          if (reason === "clickaway") return;
          setCheaperPriceToastOpen(false);
        }}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        className="cheaper-price-toast"
      >
        <Alert
          onClose={() => setCheaperPriceToastOpen(false)}
          icon={<CheckCircleRoundedIcon fontSize="inherit" />}
          severity="success"
          className="cheaper-price-toast__alert"
        >
          <strong className="cheaper-price-toast__title">
            {t("search.cheaperPriceToastTitle")}
          </strong>
          <span className="cheaper-price-toast__text">
            {t("search.cheaperPriceToast")}
          </span>
        </Alert>
      </Snackbar>
    </>
  );
};

export default Search;

function LeftArrow() {
  const { isFirstItemVisible, scrollPrev } =
    React.useContext(VisibilityContext);

  return (
    <div
      className="horizental-btn left"
      disabled={isFirstItemVisible}
      onClick={() => scrollPrev()}
    >
      <svg
        className="Icon__StyledIcon-sc-1det6wr-0 fhAORE"
        viewBox="0 0 24 24"
        preserveAspectRatio="xMidYMid meet"
      >
        <path d="M15.254 16.089c.369.333.398.904.065 1.274a.898.898 0 01-1.27.066l-5.303-4.795a.904.904 0 01.002-1.343l5.256-4.72a.898.898 0 011.271.07c.332.372.3.942-.07 1.275l-4.18 3.753a.4.4 0 000 .594l4.229 3.826z"></path>
      </svg>
    </div>
  );
}

function RightArrow() {
  const { isLastItemVisible, scrollNext } = React.useContext(VisibilityContext);

  return (
    <div
      className="horizental-btn right"
      disabled={isLastItemVisible}
      onClick={() => scrollNext()}
    >
      <svg
        className="Icon__StyledIcon-sc-1det6wr-0 fhAORE"
        viewBox="0 0 24 24"
        preserveAspectRatio="xMidYMid meet"
      >
        <path d="M8.746 16.089l4.23-3.825a.4.4 0 00-.001-.595l-4.18-3.753a.904.904 0 01-.07-1.275.898.898 0 011.27-.07l5.256 4.72c.399.358.4.983.003 1.342L9.952 17.43a.898.898 0 01-1.271-.066.904.904 0 01.065-1.274z"></path>
      </svg>
    </div>
  );
}
